import ProjectDashboard from "./projectDashboard/ProjectDashboard";
import Default from "./defaultPage/defaultPage";
import "./combined-projects.css"

export default function CombinedProjects() {
    return (
        <div id="projects-page">
            <div id="projects-columns">
                <div id="dashboard-column">
                    <div id="dashboard-wrapper">
                        <ProjectDashboard />
                    </div>
                </div>
                <div id="default-column">
                    <Default />
                </div>


            </div>

        </div>
    )
}